import { ReactNode } from 'react';
import MaskedInput from 'react-text-mask';
import { useIntl } from 'react-intl';

import { Form, FormItemProps } from 'antd';
import { maskFieldValidator } from '@/utils/mask';

import FloatingFormItem from '../FloatingFormItem';
import { removeMaskFromEvent } from '@/utils/mask/removeMask';
import { cestMask } from '@/utils/mask/commonMasks';

interface Props extends FormItemProps {
  onChange?: () => void;
  label?: ReactNode;
  fieldName?: string | string[];
  requiredRuleTextId?: string;
  lengthRuleTextId?: string;
  required?: boolean;
  disabled?: boolean;
}

const CestFormField = ({
  initialValue,
  onChange,
  label = 'CEST',
  fieldName = 'cest',
  requiredRuleTextId = 'commons.form.errors.requiredCest',
  lengthRuleTextId = 'commons.form.errors.invalidCest',
  required = true,
  disabled = false,
}: Props) => {
  const intl = useIntl();

  const form = Form.useFormInstance();

  const cestField = Form.useWatch(fieldName, form);

  const rulesRequired = required
    ? [
        {
          required: true,
          message: intl.formatMessage({ id: requiredRuleTextId }),
        },
      ]
    : [];

  const rules = [
    ...rulesRequired,
    {
      min: 7,
      max: 7,
      validator: maskFieldValidator,
      message: intl.formatMessage({ id: lengthRuleTextId }),
    },
  ];

  return (
    <FloatingFormItem
      label={label}
      name={fieldName}
      initialValue={initialValue}
      getValueFromEvent={removeMaskFromEvent}
      rules={rules}
    >
      <MaskedInput
        disabled={disabled}
        className="ant-input"
        mask={cestField?.length <= 7 ? cestMask : []}
        onChange={onChange}
      />
    </FloatingFormItem>
  );
};

export default CestFormField;
